export const environment = {
    production: false,
    urlApi: "http://localhost:8080",
    urlApiSSO: "https://qa-api-login.azurewebsites.net",
    cookieDomain: "iconstruye.cl",
    newRelic: '',
    gtmId: 'GTM-KZ93DWH',
    ga4Id: 'G-HQX7WQH7RN',
    googleMapsApiKey: '',
    features: {
        fechaDesde: "2020-01-01",
        allowedEmbeddingUrls: [],
        requireAuth: true
    },
    microfrotend: {
        notasProveedorApps: "https://qawebnotaproveedoredp.z20.web.core.windows.net/main.js"
    }
};